module.exports = __webpack_public_path__ + "static/imageTransformation-63a9f34082775e7ee91842fe57c1dd1b.png";